import UserNotFound from './UserNotFound';

export default UserNotFound;
